import { 
  TableRow, 
  TableCell,
  Grid,
  Button
} from '@mui/material';
import { TABS } from '../helpers/Tabs';
import PropTypes from 'prop-types';

const MRTableNoRecords = ({tabIndex, searchedValue, redirectToOtherTab, emptySearch}) => (
    searchedValue !== '' ? 
    <TableRow sx={{height: 360}}>
      <TableCell colSpan={10} align='center'>
        <p>No records to display. <br/> Would you like to try this search in {TABS[(tabIndex+1)%TABS.length]?.title } tab?</p>
        <Grid container gap={'2em'} justifyContent='center'>
          <Button variant="contained" disableElevation color="success" onClick = {redirectToOtherTab}>YES</Button>
          <Button variant="contained" disableElevation color="error" onClick = {emptySearch}>CANCEL</Button>
        </Grid>
      </TableCell>
    </TableRow>
    :
    <TableRow sx={{height: 360}}>
      <TableCell colSpan={10} align='center'>
        No records to display.
      </TableCell>
    </TableRow>
)

export default MRTableNoRecords;

MRTableNoRecords.propTypes = {
  tabIndex: PropTypes.number,
  searchedValue: PropTypes.string,
  setSearchedValue: PropTypes.func,
  redirectToOtherTab: PropTypes.func,
  emptySearch: PropTypes.func
}

MRTableNoRecords.defaultProps = {
  tabIndex: 1,
  searchedValue: '',
  setSearchedValue: () => {},
  redirectToOtherTab: () => {},
  emptySearch: () => {},
}